import React from "react";
import {
	DateTimeInputField,
	InputField,
	PaymentStatusField,
	SelectField,
	SelectFieldStatus,
	TextAreaField,
} from "../../../components/Form/FormComponents";
import { getLeasorName, getUserName, getInvestorEmail, getInvestorName } from "../utils";
import { getFormattedDate } from "../../../utils/DateUtils";
import { getRequestValue } from "../../../utils/Utils";
import { DeliveryTypeArray, DurationOptions, PaymentTypeOptions } from "../../../Constants";
import { getNairaFormat } from "../../../utils/Utils";
import { LeaseStructureOptions } from "../data";
import { CustomSmallBtn } from "../Lease.styled";
import FileUpload from "../../logistics/partials/FileUpload";

/* eslint-disable react/prop-types */

export const LeaseInformation = ({ formData, isEditable, handleInputChange, page }) => {
	return (
		<>
			<div className='form-group'>
				<label>DATE / TIME</label>
				<InputField name='createdAt' value={getFormattedDate(formData?.createdAt)} />
			</div>

			<div className='form-group'>
				<label>TRN ID</label>
				<InputField name='trnId' value={"TRN-" + formData?.objectId} />
			</div>

			<div className='form-group'>
				<label>ASSET</label>
				<InputField name='productName' value={formData?.productName} />
			</div>

			<div className='form-group'>
				{/* {formData?.profile === "Investor" ? <label>LEASOR</label> : <label>BUSINESS NAME</label>} */}
				<label>LEASOR</label>
				<InputField name='leasor' value={getLeasorName(formData)} />
			</div>

			<div className='form-group'>
				<label>LEASEE</label>
				<InputField name='leasee' value={getUserName(formData)} />
			</div>

			<div className='form-group'>
				<label>CATEGORY</label>
				<InputField name='productCategory' value={formData?.productCategory} />
			</div>

			<div className='form-group'>
				<label>LEASE TYPE</label>
				<SelectField
					name='leaseType'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.leaseType}
					options={["Quick Lease", "Sponsored Lease"]}
				/>
			</div>

			<div className='form-group'>
				<label>LEASE STRUCTURE</label>
				<SelectField
					name='leaseStructure'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.leaseStructure}
					options={LeaseStructureOptions}
				/>
			</div>

			<div className='form-group'>
				<label>LEASE DURATION</label>
				<SelectField
					name='leaseDuration'
					value={formData?.leaseDuration}
					handleChange={handleInputChange}
					isEditable={isEditable}
					options={DurationOptions}
				/>
			</div>

			<div className='form-group'>
				<label>INTEREST RATE</label>
				<InputField name='interest' value={formData?.interest} />
			</div>

			<div className='form-group'>
				<label>PRICE</label>
				<InputField name='price' value={getNairaFormat(formData?.price)} />
			</div>

			<div className='form-group'>
				<label>INSURANCE</label>
				<SelectField name='insurance' value={formData?.insurance} />
			</div>

			<div className='form-group'>
				<label>PAYMENT TYPE</label>
				<SelectField
					name='paymentType'
					value={formData?.paymentType}
					handleChange={handleInputChange}
					isEditable={isEditable}
					options={PaymentTypeOptions}
				/>
			</div>

			<div className='form-group'>
				<label>DELIVERY FEE</label>
				<InputField
					name='deliveryFee'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.deliveryFee}
				/>
			</div>

			<div className='form-group'>
				<label>DELIVERY METHOD</label>
				<SelectField
					name='deliveryType'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.deliveryType}
					options={DeliveryTypeArray}
				/>
			</div>

			<div className='form-group'>
				<label>DELIVERY STATUS</label>
				<SelectField
					name='delivery_status'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.delivery_status}
					options={["not delivered", "delivered"]}
				/>
			</div>

			<div className='form-group'>
				<label>PAYMENT</label>
				<SelectFieldStatus
					name='paymentStatus'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.paymentStatus}
					type={formData?.paymentStatus?.toLowerCase()}
					options={["pending", "approved", "default"]}
				/>
			</div>

			{page === "ongoing" || page === "investor" ? (
				<>
					<div className='form-group'>
						<label>REQUEST</label>
						<InputField name='request' value={getRequestValue(formData)} />
					</div>
				</>
			) : (
				<>
					<div className='form-group'>
						<label>OUTSTANDING</label>
						<InputField
							name='outstanding'
							handleChange={handleInputChange}
							// isEditable={isEditable}
							value={formData?.outstanding}
						/>
					</div>

					<div className='form-group'>
						<label>NEXT PAYMENT</label>
						<InputField
							name='next_payment'
							handleChange={handleInputChange}
							// isEditable={isEditable}
							value={formData?.next_payment}
						/>
					</div>

					<div className='form-group'>
						<label>REQUEST</label>
						<InputField name='request' value={getRequestValue(formData)} />
					</div>
				</>
			)}
		</>
	);
};

export const LeaseInformInvestor = ({
	formData,
	//  isEditable, handleInputChange
}) => {
	return (
		<>
			<div className='form-group'>
				<label>DATE / TIME</label>
				<InputField name='createdAt' value={getFormattedDate(formData?.createdAt)} />
			</div>

			<div className='form-group'>
				<label>ASSET NAME</label>
				<InputField name='productName' value={formData?.productName} />
			</div>

			<div className='form-group'>
				<label>CATEGORY</label>
				<InputField name='productCategory' value={formData?.category} />
			</div>

			<div className='form-group'>
				<label>BRAND</label>
				<InputField name='brand' value={formData?.brand} />
			</div>

			<div className='form-group'>
				<label>MODEL</label>
				<InputField name='model' value={formData?.model} />
			</div>

			<div className='form-group'>
				<label>YEAR</label>
				<InputField name='year' value={formData?.year} />
			</div>

			<div className='form-group'>
				<label>CONDITION</label>
				<InputField name='condition' value={formData?.condition} />
			</div>

			<div className='form-group'>
				<label>COLOR</label>
				<InputField name='color' value={formData?.color} />
			</div>

			<div className='form-group'>
				<label>TRN ID</label>
				<InputField name='trnId' value={"TRN-" + formData?.objectId} />
			</div>

			<div className='form-group'>
				<label>STATUS</label>
				<SelectFieldStatus
					name='status'
					// handleChange={handleInputChange}
					// isEditable={isEditable}
					type={formData?.status?.toLowerCase()}
					value={formData?.status}
					options={["pending", "active", "inactive"]}
				/>
			</div>

			<div className='form-group'>
				<label>REQUEST</label>
				<InputField name='request_type' value={getRequestValue(formData)} />
			</div>
		</>
	);
};

export const LeaseInformAsset = ({
	formData,
	isEditable,
	handleInputChange,
	paymentStatus,
	insurancePaymentStatus,
}) => {
	return (
		<>
			<div className='form-group'>
				<label>DATE / TIME</label>
				<InputField
					name='createdAt'
					handleChange={handleInputChange}
					value={getFormattedDate(formData?.createdAt)}
				/>
			</div>

			<div className='form-group'>
				<label>TRN ID</label>
				<InputField name='trnId' value={"TRN-" + formData?.objectId} />
			</div>

			<div className='form-group'>
				<label>ASSET</label>
				<InputField name='productName' handleChange={handleInputChange} value={formData?.productName} />
			</div>

			<div className='form-group'>
				<label>INVESTOR</label>
				<InputField name='leasee' handleChange={handleInputChange} value={getUserName(formData)} />
			</div>

			<div className='form-group'>
				<label>LEASE TYPE</label>
				<SelectField
					name='leaseType'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.leaseType}
					options={["Quick Lease", "Sponsored Lease"]}
				/>
			</div>

			<div className='form-group'>
				<label>CATEGORY</label>
				<InputField name='productCategory' handleChange={handleInputChange} value={formData?.category} />
			</div>

			<div className='form-group'>
				<label>BRAND</label>
				<InputField name='brand' handleChange={handleInputChange} value={formData?.brand} />
			</div>

			<div className='form-group'>
				<label>MODEL</label>
				<InputField name='model' handleChange={handleInputChange} value={formData?.model} />
			</div>

			<div className='form-group'>
				<label>YEAR</label>
				<InputField name='year' handleChange={handleInputChange} value={formData?.year} />
			</div>

			<div className='form-group'>
				<label>CONDITION</label>
				<InputField name='condition' handleChange={handleInputChange} value={formData?.condition} />
			</div>

			<div className='form-group'>
				<label>COLOR</label>
				<InputField name='color' handleChange={handleInputChange} value={formData?.color} />
			</div>

			<div className='form-group'>
				<label>AMOUNT</label>
				<InputField
					name='amount'
					handleChange={handleInputChange}
					// isEditable={isEditable}
					value={formData?.amount}
				/>
			</div>

			{/* <div className='form-group'>
				<label>AMOUNT TO INVEST</label>
				<InputField
					name='amountToInvest'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={getNairaFormat(formData?.amountToInvest)}
				/>
			</div> */}

			{/* <div className='form-group'>
							<label>LEASE TENURE</label>
							<InputField
								name='lease_tenure'
								handleChange={handleInputChange}
								isEditable={isEditable}
								value={formData?.lease_tenure}
							/>
						</div> */}

			<div className='form-group'>
				<label>LEASE STRUCTURE</label>
				<InputField
					name='leaseStructure'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.leaseStructure}
				/>
			</div>

			<div className='form-group'>
				<label>LEASE DURATION</label>
				<InputField
					name='leaseDuration'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.leaseDuration}
				/>
			</div>

			<div className='form-group'>
				<label>LOGISTIC STATUS</label>
				<InputField name='trnId' value={formData?.logisticStatus} />
			</div>

			{formData?.category === "Vehicles" ? (
				<>
					<div className='form-group'>
						<label>ENGINE NUMBER</label>
						<InputField name='engineNum' value={formData?.assetRegInfo?.vehicleInfo?.engineNum} />
					</div>
					<div className='form-group'>
						<label>CHASSIS NUMBER</label>
						<InputField name='chassisNum' value={formData?.assetRegInfo?.vehicleInfo?.chassisNum} />
					</div>
					<div className='form-group'>
						<label>ASSET INVOICE</label>
						<FileUpload
							name='assetInvoice'
							fileInfo={formData?.assetRegInfo?.vehicleInfo?.assetInvoice}
							isDisabled
						/>
					</div>
					<div className='form-group'>
						<label>REG. PAYMENT STATUS</label>
						<PaymentStatusField status={paymentStatus} />
					</div>
					<div className='form-group'>
						<label>REGISTRATION STATUS.</label>
						<InputField name='registrationStatus' value={formData?.vehicleRegDetails?.registrationStatus} />
					</div>
					<div className='form-group'>
						<label>REGISTRATION NO.</label>
						<InputField name='registrationNum' value={formData?.vehicleRegDetails?.registrationNum} />
					</div>
				</>
			) : (
				<>
					<div className='form-group'>
						<label>ASSET INVOICE</label>
						<FileUpload name='assetInvoice' fileInfo={formData?.assetInvoice} isDisabled />
					</div>
				</>
			)}
			<div className='form-group'>
				<label>INS. PAYMENT STATUS</label>
				<PaymentStatusField status={insurancePaymentStatus} />
			</div>
			<div className='form-group'>
				<label>INSURANCE STATUS</label>
				<InputField name='status' value={formData?.insuranceDetails?.status} />
			</div>
		</>
	);
};

// General
export const LeasorInformation = ({ formData }) => {
	return (
		<div className='grid grid-cols-3 gap-3'>
			<div className='form-group'>
				<label>LEASOR</label>
				<InputField name='leasor' value={formData?.admin} />
			</div>

			<div className='form-group'>
				<label>ITEM ADDRESS</label>
				<InputField name='item_address' value={formData?.deliveryAddress} />
			</div>

			<div className='form-group'>
				<label>PHONE NUMBER</label>
				<InputField name='phone_number' value={formData?.phone_number} />
			</div>
		</div>
	);
};

export const LeaseeInformation = ({ formData }) => {
	return (
		<div className='grid grid-cols-3 gap-3'>
			<div className='form-group'>
				<label>LEASEE</label>
				<InputField name='leasee' value={getUserName(formData)} />
			</div>

			<div className='form-group'>
				<label>DELIVERY ADDRESS</label>
				<InputField
					name='delivery_address'
					value={formData?.userId?.homeAddress || formData?.user?.homeAddress}
				/>
			</div>

			<div className='form-group'>
				<label>PHONE NUMBER</label>
				<InputField name='phone_number' value={formData?.userId?.phone || formData?.user?.phone} />
			</div>
		</div>
	);
};

export const Guarantor_1 = ({ formData }) => {
	return (
		<div className='grid grid-cols-3 gap-3'>
			<div className='form-group'>
				<label>NAME</label>
				<InputField name='guarantor_name1' value={formData?.guarantor?.name1} />
			</div>

			{/* <div className='form-group'>
				<label>RESIDENTIAL ADDRESS</label>
				<InputField
					name='guarantor_1_residential_address'
					value={formData?.guarantor?.phone1}
				/>
			</div> */}

			{/* <div className='form-group'>
				<label>OCCUPATION</label>
				<InputField name='guarantor_1_occupation' value={formData?.guarantor?.phone1} />
			</div> */}

			<div className='form-group'>
				<label>PHONE</label>
				<InputField name='guarantor_phone1' value={formData?.guarantor?.phone1} />
			</div>

			<div className='form-group'>
				<label>EMAIL</label>
				<InputField name='guarantor_phone1' value={formData?.guarantor?.email1} />
			</div>

			{/* <div className='form-group'>
				<label>RELATIONSHIP</label>
				<InputField name='guarantor_1_relationship' value={formData?.guarantor?.phone1} />
			</div>

			<div className='form-group'>
				<label>BANK STATEMENT</label>
				<FileGroup name='bank_statement_g1' />
			</div> */}
		</div>
	);
};

export const Guarantor_2 = ({ formData }) => {
	return (
		<div className='grid grid-cols-3 gap-3'>
			<div className='form-group'>
				<label>NAME</label>
				<InputField name='guarantor_2_name' value={formData?.guarantor?.name2} />
			</div>

			{/* <div className='form-group'>
				<label>RESIDENTIAL ADDRESS</label>
				<InputField
					name='guarantor_2_residential_address'
					value={formData?.guarantor?.name2}
				/>
			</div>

			<div className='form-group'>
				<label>OCCUPATION</label>
				<InputField name='guarantor_2_occupation' value={formData?.guarantor?.name2} />
			</div> */}

			<div className='form-group'>
				<label>PHONE</label>
				<InputField name='guarantor_2_phone' value={formData?.guarantor?.phone2} />
			</div>

			<div className='form-group'>
				<label>EMAIL</label>
				<InputField name='guarantor_2_email' value={formData?.guarantor?.email2} />
			</div>

			{/* <div className='form-group'>
				<label>RELATIONSHIP</label>
				<InputField name='guarantor_2_relationship' value={formData?.guarantor?.name2} />
			</div>

			<div className='form-group'>
				<label>BANK STATEMENT</label>
				<FileGroup name='bank_statement_g2' />
			</div> */}
		</div>
	);
};

export const NegotiatorsGroup = ({ formData }) => {
	return (
		<div className='grid grid-cols-4 gap-3'>
			<div className='form-group'>
				<label>NEGOTIATOR</label>
				<InputField name='negotiator_name' value={formData?.negotiator_name} />
			</div>

			<div className='grid'>
				<div className='form-group'>
					<label>LEASE TERM</label>
					<InputField name='negotiator_lease_term' value={formData?.negotiator_lease_term} />
				</div>

				<div className='form-group'>
					<label>INTEREST RATE</label>
					<InputField name='negotiator_lease_term' value={formData?.negotiator_lease_term} />
				</div>

				<div className='form-group'>
					<label>LEASE STRUCTURE</label>
					<InputField name='negotiator_lease_term' value={formData?.negotiator_lease_term} />
				</div>
			</div>

			<div className='grid'>
				<div className='form-group'>
					<label>PROPOSAL</label>
					<InputField name='negotiator_proposal' value={formData?.negotiator_proposal} />
				</div>

				<div className='form-group'>
					<label>PROPOSAL</label>
					<InputField name='negotiator_proposal' value={formData?.negotiator_proposal} />
				</div>

				<div className='form-group'>
					<label>PROPOSAL</label>
					<InputField name='negotiator_proposal' value={formData?.negotiator_proposal} />
				</div>
			</div>

			<div className='form-group'>
				<label>STATUS</label>
				<InputField name='negotiator_status' value={formData?.negotiator_status} />
			</div>
		</div>
	);
};

export const CompletedAssetInformation = ({ formData }) => {
	return (
		<div className='grid grid-cols-3 gap-3'>
			<div className='form-group'>
				<label>DATE / TIME</label>
				<InputField name='createdAt' value={getFormattedDate(formData?.createdAt)} />
			</div>

			<div className='form-group'>
				<label>TRN ID</label>
				<InputField name='trnId' value={"TRN-" + formData?.objectId} />
			</div>

			<div className='form-group'>
				<label>LEASEE</label>
				<InputField name='leasee' value={getUserName(formData)} />
			</div>

			<div className='form-group'>
				<label>LEASE TYPE</label>
				<InputField name='productCategory' value={formData?.leaseType} />
			</div>

			<div className='form-group'>
				<label>LEASE STRUCTURE</label>
				<InputField name='productCategory' value={formData?.leaseStructure} />
			</div>

			<div className='form-group'>
				<label>LEASE DURATION</label>
				<InputField name='productCategory' value={formData?.leaseDuration} />
			</div>

			<div className='form-group'>
				<label>DATE OF AGREEMENT</label>
				<InputField name='color' value={new Date(`${formData?.leaseAgreement?.date}`).toDateString()} />
			</div>

			<div className='form-group'>
				<label>INTEREST RATE</label>
				<InputField name='interest' value={formData?.interest} />
			</div>
		</div>
	);
};

export const CompletedAssetProductInfo = ({ formData }) => {
	return (
		<div className='grid grid-cols-3 gap-3'>
			<div className='form-group'>
				<label>NAME</label>
				<InputField name='productCategory' value={formData?.productObj?.productName} />
			</div>
			<div className='form-group'>
				<label>CATEGORY</label>
				<InputField name='productCategory' value={formData?.productObj?.category} />
			</div>
			<div className='form-group'>
				<label>CATEGORY</label>
				<InputField name='productCategory' value={formData?.productObj?.subCategory} />
			</div>
			<div className='form-group'>
				<label>BRAND</label>
				<InputField name='productCategory' value={formData?.productObj?.brand} />
			</div>
			<div className='form-group'>
				<label>MODEL</label>
				<InputField name='productCategory' value={formData?.productObj?.model} />
			</div>
			<div className='form-group'>
				<label>AMOUNT</label>
				<InputField name='productCategory' value={getNairaFormat(formData?.productObj?.amount)} />
			</div>
			<div className='form-group' style={{ gridColumn: "1/4" }}>
				<label>PRODUCT DESCRIPTION</label>
				<TextAreaField
					name='product_desc'
					value={formData?.description || formData?.productId?.description}
				/>
			</div>
			<div className='form-group' style={{ gridColumn: "1/4" }}>
				<label>PRODUCT FEATURES</label>
				<TextAreaField
					name='product_features'
					value={formData?.keyFeatures && formData?.keyFeatures?.replace(/;/g, "<br/>")}
				/>
			</div>
			<div className='form-group' style={{ gridColumn: "1/4" }}>
				<label>PRODUCT FEATURES</label>
				<TextAreaField
					name='product_specs'
					value={formData?.specifications && formData?.specifications?.replace(/;/g, "<br/>")}
				/>
			</div>
		</div>
	);
};

export const AssetRegistrationInfo = ({
	formData,
	toggleEdit,
	handleChange,
	handleClick,
	canRegisterAsset,
	miniForm,
}) => {
	return (
		<div className='grid grid-cols-3 gap-3'>
			<div className='form-group'>
				<label>REGISTRATION DATE</label>
				<DateTimeInputField value={formData?.vehicleRegDetails?.registrationDate?.iso} />
			</div>
			<div className='form-group'>
				<label>INVESTOR&apos;S NAME.</label>
				<InputField name='engineNum' value={getInvestorName(formData)} />
			</div>
			<div className='form-group'>
				<label>INVESTOR&apos;S EMAIL.</label>
				<InputField name='engineNum' value={getInvestorEmail(formData)} />
			</div>
			<div className='form-group'>
				<label>CHASSIS NO.</label>
				<InputField name='chassisNum' value={formData?.vehicleInfo?.chassisNum} />
			</div>
			<div className='form-group'>
				<label>ENGINE NO.</label>
				<InputField name='engineNum' value={formData?.vehicleInfo?.engineNum} />
			</div>
			<div className='form-group'>
				<label>ASSET INVOICE</label>
				<FileUpload fileInfo={formData?.vehicleInfo?.assetInvoice} name='assetInvoice' isDisabled />
			</div>

			<div className='form-group'>
				<label>PAYMENT STATUS</label>
				<PaymentStatusField status={miniForm?.paymentStatus} />
			</div>

			<div className='form-group'>
				<label>REGISTRATION NO.</label>
				<InputField
					name='registrationNum'
					value={miniForm?.registrationNum?.toUpperCase()}
					isEditable={toggleEdit}
					handleChange={handleChange}
				/>
			</div>
			<div className='form-group'>
				<label>REGISTRATION STATUS</label>
				<SelectField
					name='registrationStatus'
					value={miniForm?.registrationStatus}
					handleChange={handleChange}
					options={["Pending", "Ongoing", "Registered"]}
					isEditable={toggleEdit}
				/>
			</div>
			{canRegisterAsset && (
				<div className='form-group' style={{ gridColumn: "3/4", gridRow: "4/5" }}>
					<CustomSmallBtn
						style={{ height: "45px", color: "white", background: "#006770" }}
						type='button'
						onClick={handleClick}>
						Register Asset
					</CustomSmallBtn>
				</div>
			)}
		</div>
	);
};

export const InsureAssetInfo = ({ formData, insurance, handleRegisterAsset, canRegisterAsset }) => {
	// console.log(insurance);
	return (
		<div className='grid grid-cols-3 gap-3'>
			<div className='form-group'>
				<label>DATE OF INSURANCE</label>
				<DateTimeInputField name='dateInsured' value={insurance?.dateInsured?.iso} />
			</div>

			<div className='form-group'>
				<label>INVESTOR&apos;S NAME</label>
				<InputField name='investorEmail' value={insurance?.investorName} />
			</div>

			<div className='form-group'>
				<label>INVESTOR&apos;S EMAIL</label>
				<InputField name='investorEmail' value={insurance?.investorEmail} />
			</div>

			<div className='form-group'>
				<label>INVESTOR&apos;S PHONE NO.</label>
				<InputField name='investorPhone' value={insurance?.investorPhone} />
			</div>

			<div className='form-group'>
				<label>OCCUPATION</label>
				<InputField name='occupation' value={insurance?.occupation} />
			</div>

			<div className='form-group'>
				<label>GENDER</label>
				<InputField name='gender' value={insurance?.gender} />
			</div>

			<div className='form-group'>
				<label>COUNTRY</label>
				<InputField name='country' value={insurance?.country} />
			</div>

			<div className='form-group'>
				<label>STATE</label>
				<InputField name='state' value={insurance?.state} />
			</div>

			<div className='form-group'>
				<label>CITY</label>
				<InputField name='city' value={insurance?.city} />
			</div>

			<div className='form-group'>
				<label>POSTAL CODE</label>
				<InputField name='postalCode' value={insurance?.postalCode} />
			</div>

			{formData?.productCategory === "Vehicles" && (
				<>
					<div className='form-group'>
						<label>CHASSIS NO.</label>
						<InputField name='chassisNum' value={formData?.vehicleInfo?.chassisNum} />
					</div>
					<div className='form-group'>
						<label>ENGINE NO.</label>
						<InputField name='engineNum' value={formData?.vehicleInfo?.engineNum} />
					</div>
					<div className='form-group'>
						<label>REGISTRATION NO.</label>
						<InputField name='regNo' value={formData?.vehicleRegDetails?.registrationNum?.toUpperCase()} />
					</div>
				</>
			)}

			<div className='form-group'>
				<label>ASSEET INVOICE</label>
				{insurance?.assetInvoice ? (
					<FileUpload fileInfo={insurance?.assetInvoice} name='assetInvoice' isDisabled />
				) : (
					<p className='inputText'>---</p>
				)}
			</div>

			<div className='form-group'>
				<label>ID TYPE</label>
				<InputField name='idType' value={insurance?.idType} />
			</div>

			<div className='form-group'>
				<label>ID NUMBER</label>
				<InputField name='idNumber' value={insurance?.idNumber} />
			</div>

			<div className='form-group'>
				<label>ID CARD</label>
				<FileUpload fileInfo={insurance?.idCard} name='idCard' isDisabled />
			</div>

			<div className='form-group'>
				<label>UTILITY BILL</label>
				<FileUpload fileInfo={insurance?.utilityBill} name='utilityBill' isDisabled />
			</div>

			<div className='form-group'>
				<label>PAYMENT STATUS</label>
				<PaymentStatusField status={insurance?.paymentStatus} />
			</div>
			<div className='form-group'>
				<label>INSURANCE STATUS</label>
				<p style={{ fontWeight: "600", textTransform: "capitalize" }}>{insurance?.status}</p>
			</div>
			{canRegisterAsset && (
				<div className='form-group' style={{ gridColumn: "3/4", gridRow: "8/9" }}>
					<CustomSmallBtn
						style={{ height: "45px", color: "white", background: "#006770" }}
						type='button'
						onClick={handleRegisterAsset}>
						Pay For Insurance
					</CustomSmallBtn>
				</div>
			)}
		</div>
	);
};
